import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useDispatch, useSelector } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import moment from "moment";
import { useEffect } from "react";
import PropTypes from "prop-types";
import Table from "./Table";
import { JobCategories } from "../../utilities/constants";
import { capitalizeFirstLetter } from "../../utilities";
import { getCompanyWiseData } from "../../redux/company/actions";

const columns = () => [
  {
    id: "id",
    label: "ID",
    props: {
      align: "center",
    },
  },
  {
    id: "title",
    label: "Title",
    value: (row) => (
      <Typography
        component={RouterLink}
        to={`/jobs/${row.id}`}
        sx={{
          textDecoration: "none",
          "&:hover": {
            color: "#C02026",
          },
        }}>
        {row?.title}
      </Typography>
    ),
    props: {
      align: "center",
    },
  },
  {
    id: "status",
    label: "Status",
    value: (row) => row.status,
    props: {
      align: "center",
    },
  },
  {
    id: "address",
    label: "Address",
    value: (row) => (
      <span>
        {row?.address &&
          row?.address?.country &&
          row?.address?.city &&
          row?.address?.zipCode &&
          row?.address?.address &&
          `${row?.address?.country}, 
                                ${row?.address?.city} ${row?.address?.zipCode}, 
                                ${row?.address?.address}`}
      </span>
    ),
    props: {
      align: "center",
    },
  },
  {
    id: "createdAt",
    label: "Created Date",
    value: (row) => capitalizeFirstLetter(moment(row.createdAt).format("DD/MM/YYYY")),
  },
  {
    id: "category",
    label: "Category",
    value: (row) => (row.jobCategories || []).map((i) => JobCategories.getLabel(i)).join(", "),
    props: {
      align: "center",
    },
  },
  {
    id: "candidateCount",
    label: "Applied Candidates",
    value: (row) => row.candidateCount,
    props: {
      align: "center",
    },
  },
];

const CompanyJobList = ({ id }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.companies.loading);
  const jobs = useSelector((state) => state.companies.companyWiseJob);

  useEffect(() => {
    dispatch(getCompanyWiseData({ companyId: id }));
  }, []);

  return (
    !isLoading && (
      <Box sx={{ width: { xs: "100%", md: "100%" }, margin: "auto", mt: "25px" }}>
        <Table data={jobs || []} columns={columns()} isLoading={isLoading} noResultsContent="There are no available jobs." />
      </Box>
    )
  );
};

CompanyJobList.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default CompanyJobList;
